const ActiveApplications = [
  {
    name: "Merilyn SSL",
    version: "18",
    alias: "Merilyn",
    url: "https://merilyn.yarillo.com/",
    removedColumns: [],
    allowedExportTypes: ["aggregate", "all"],
  },
  {
    name: "Corset",
    version: "20",
    alias: "Corset",
    url: "https://corset.yarillo.com/",
    removedColumns: [],
    allowedExportTypes: ["aggregate", "all"],
  },
  {	  
    name: "King",
    version: "30",
    alias: "King",
    url: "https://king.yarillo.com/",
    removedColumns: [],
    allowedExportTypes: ["aggregate", "all"],
  },
  {	  
    name: "Esse",
    version: "1",
    alias: "Esse",
    url: "https://esse.yarillo.com/",
    removedColumns: [],
    allowedExportTypes: ["aggregate", "all"],
  },    
];

export default ActiveApplications;
